var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSponsorship(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 30,
    height: 30,
    rx: 4
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 30,
    height: 30,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Finance",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Finance_Initial-(Desktop)",
    transform: "translate(-875.000000, -459.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-45",
    transform: "translate(845.000000, 297.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Transactions_Sponsorship",
    transform: "translate(30.000000, 162.000000)"
  }, /*#__PURE__*/React.createElement("use", {
    id: "Rectangle",
    stroke: "transparent",
    mask: "url(#mask-2)",
    strokeWidth: 1.6,
    strokeDasharray: "0,0",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun_deal_2435120",
    transform: "translate(5.000000, 8.000000)",
    fill: "#000000",
    opacity: 0.699999988,
    stroke: "#000000",
    strokeWidth: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6551724,1.5879017 L16.6448276,1.5879017 L13.5296552,0.0354442344 C13.4834483,0.0120510397 13.4310345,0 13.3793103,0 L10.3862069,0 C10.2813793,0 10.182069,0.0489130435 10.1165517,0.133270321 L8.98413793,1.5879017 L4.97931034,1.5879017 C4.91103448,1.5879017 4.84482759,1.60845936 4.78827586,1.64744802 L2.55793103,3.1758034 L0.344827586,3.1758034 C0.154482759,3.1758034 0,3.33459357 0,3.53024575 L0,10.6758034 C0,10.8714556 0.154482759,11.0302457 0.344827586,11.0302457 L3.33586207,11.0302457 L9.43172414,14.9461248 C9.4862069,14.981569 9.54965517,15 9.61448276,15 L11.1586207,15 C11.2503448,15 11.337931,14.9624291 11.4027586,14.8965028 L16.037931,10.1327977 C16.1027586,10.0661626 16.1386207,9.97613422 16.1386207,9.88185255 L16.1386207,9.44234405 L19.6551724,9.44234405 C19.8455172,9.44234405 20,9.28355388 20,9.0879017 L20,1.94234405 C20,1.74669187 19.8455172,1.5879017 19.6551724,1.5879017 Z M15.4482759,9.73511342 L11.0151724,14.2911153 L9.71241379,14.2911153 L3.61655172,10.3752363 C3.56206897,10.3397921 3.49862069,10.3213611 3.4337931,10.3213611 L0.689655172,10.3213611 L0.689655172,3.88468809 L2.66206897,3.88468809 C2.73034483,3.88468809 2.79655172,3.86413043 2.85310345,3.82514178 L5.08344828,2.29678639 L8.43241379,2.29678639 L7.03310345,4.09522684 C6.5937931,4.62830813 6.4737931,5.24929112 6.69586207,5.84404537 C6.94896552,6.52386578 7.64413793,7.07325142 8.3862069,7.17887524 C9.01931034,7.26961248 9.59310345,7.02859168 9.95172414,6.53449905 L11.9544828,4.05482042 L15.4482759,7.64603025 L15.4482759,9.73511342 Z M19.3103448,8.73345936 L16.137931,8.73345936 L16.137931,7.5 C16.137931,7.40571834 16.1013793,7.31568998 16.0372414,7.24905482 L12.1744828,3.27930057 C12.1055172,3.2084121 12.0131034,3.17367675 11.9144828,3.1758034 C11.8172414,3.18005671 11.7275862,3.2268431 11.6655172,3.30340265 L9.40965517,6.09640832 C9.13103448,6.47991493 8.7537931,6.51465028 8.48,6.47637051 C7.98344828,6.40548204 7.50413793,6.03331758 7.33931034,5.59026465 C7.20896552,5.23794896 7.28275862,4.88917769 7.56551724,4.54465974 L10.5517241,0.708884688 L13.3,0.708884688 L16.4151724,2.26134216 C16.4613793,2.28473535 16.5137931,2.29678639 16.5655172,2.29678639 L19.3103448,2.29678639 L19.3103448,8.73345936 Z",
    id: "Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSponsorship);
export default __webpack_public_path__ + "static/media/sponsorship.48e6eae0ec9309959dc14f94f010c832.svg";
export { ForwardRef as ReactComponent };